export default async function init() {
  const elements = document.querySelectorAll('.image-glow');

  if (elements.length) {
    const { default: ImageGlow } = await import(/* webpackChunkName: "image-glow" */ './image-glow');

    elements.forEach((element) => new ImageGlow(element));
  }
}
